import Vue from "vue"
import Router from "vue-router"

import store from "@/store/index"
import Home from "@/views/default/Home"
import GetToken from "@/views/default/GetToken"
import Error from "@/views/default/Error"
import account from "@/config/modules/account"
import maintain from "@/config/modules/maintain"
import quotation from "@/config/modules/quotation"
import consignment from "@/config/modules/consignment"
import pcneol from "@/config/modules/pcneol"
import ap from "@/config/modules/ap"
import * as types from '@/store/mutations_types.js'
import {
  getCookie,
  setCookie,
  delCookie
} from "@/util/cookie"

Vue.use(Router)

const router = new Router({
  // mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
    },
    {
      path: "/getToken",
      name: "GetToken",
      component: GetToken,
    },
    {
      path: "/error",
      name: "Error",
      component: Error,
    },
    ...account,
    ...maintain,
    ...quotation,
    ...consignment,
    ...pcneol,
    ...ap,
    {
      path: "*",
      redirect: "/home",
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (!getCookie("LOGIN-ACCOUNT")) {
    setCookie("LOGIN-ACCOUNT", 1, 1000 * 60 * 60 * 5)
  } else {
    setCookie("LOGIN-ACCOUNT", Number(getCookie("LOGIN-ACCOUNT")) + 1, 1000 * 60 * 60 * 5)
  }

  if (to.query.token) {
    setCookie(process.env.VUE_APP_AUTH_TOKEN_NAME, to.query.token, 1000 * 60 * 60 * 5)
    store.commit(types.LOGIN, true)
    store.commit(types.REDIRECT_URL, to.path)
    next({
      path: '/getToken',
    })
  }

  if (getCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)) {
    store.commit(types.LOGIN, true)
    delCookie("LOGIN-ACCOUNT")
    next()
  } else {
    if (to.path == '/home') {
      next()
    } else {
      store.commit(types.LOGIN, false)
      if (Number(getCookie("LOGIN-ACCOUNT")) < 3) {
        if (process.env.VUE_APP_IS_ON_EXTERNAL == "T") {
          window.location.href = `${process.env.VUE_APP_AUTH_URL}#/auth/login?redirectUrl=` + encodeURIComponent(`${process.env.VUE_APP_FRONTEND_URL}/#` + to.path)
        } else {
          window.location.href = `${process.env.VUE_APP_AUTH_URL}api/auth/redirect?redirectUrl=` + encodeURIComponent(`${process.env.VUE_APP_FRONTEND_URL}/#` + to.path)
        } 
      } else {
        window.location.href = `${process.env.VUE_APP_AUTH_URL}#/auth/login?redirectUrl=` + encodeURIComponent(`${process.env.VUE_APP_FRONTEND_URL}/#` + to.path)
      }
    }
  }

  // 跳轉 Vue3
    console.log(to)
  if (to.meta?.tag?.includes('toVue3')) {
    setCookie('userCode', store.getters.getGroupCode.code, 1000 * 60 * 60 * 5)
    setCookie('mainRole', store.getters.getUserProfile?.selectedGroup?.mainRoles[0]?.code, 1000 * 60 * 60 * 5)
    const baseUrl = process.env.VUE_APP_FRONTEND_VUE3_URL + '#' // 假設此變數定義為前端基本 URL
    window.location.href = `${baseUrl}${to.path}`
  }

})

export default router
